import { useContext } from "react";

import { useQuery } from "@apollo/client";
import { useParams } from "react-router-dom";

import NotFound from "@/components/pages_public/404";
import Article from "@/components/pieces/article";
import { ArticleWithReadStatus } from "@/components/pieces/learn/ArticleCard";
import ArticleSkeleton from "@/components/pieces/learn/ArticleSkeleton";
import { ResponseContext } from "@/components/ResponseContext";
import { hasValidToken } from "@/components/session/JwtTokenManager";
import {
  ArticleDocument,
  ArticleQuery,
  ArticleQueryVariables,
} from "@/graphql";

export default function LearnArticle() {
  const { res } = useContext(ResponseContext);
  const { slug } = useParams();

  const { data } = useQuery<ArticleQuery, ArticleQueryVariables>(
    ArticleDocument,
    {
      fetchPolicy:
        import.meta.env.SSR || hasValidToken()
          ? "cache-and-network"
          : undefined,
      variables: {
        slug,
      },
    },
  );

  if (!data) {
    return <ArticleSkeleton />;
  }

  const { article, articleReadStatus } = data;
  let updatedArticle = { ...article } as ArticleWithReadStatus;
  if (article && articleReadStatus) {
    updatedArticle = {
      ...article,
      currentUserReadStatus: articleReadStatus.readStatus,
    } as ArticleWithReadStatus;
  }

  if (!updatedArticle) {
    if (res) {
      res.status(404);
    }
    return <NotFound />;
  }

  return <Article article={updatedArticle} />;
}
